import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {SrmPointChecklist} from "../../../../generated-model/model";
import {SharedCommonModule} from "../../commons/shared-common.module";
import {FormsModule} from "@angular/forms";
import {PointChecklistTableComponent} from "../point-checklist-table/point-checklist-table.component";

@Component({
  selector: 'app-enroll-modal',
  templateUrl: './point-checklist-modal.component.html',
  styleUrls: ['./point-checklist-modal.component.css'],
  imports: [
    SharedCommonModule,
    FormsModule,
    PointChecklistTableComponent
  ],
  standalone: true
})
export class PointChecklistModalComponent implements OnInit {
  @Input() checklist: SrmPointChecklist[] = [];

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.close(false);
  }

  select() {
    this.activeModal.close(true);
  }
}
